import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastService } from 'src/app/core/services/toaster.service';
import InventoryManagementService from 'src/app/modules/custom-landing/inventory-unpublished-batch/inventory-management.service';
import { FormsModule } from '@angular/forms';
import { TwoDigitDecimaNumberDirective, CopyDirective } from '../two-digit-decima-number.directive';
import { NgIf } from '@angular/common';

@Component({
    selector: 'app-publish-batch-modal',
    templateUrl: './publish-batch-modal.component.html',
    styleUrls: ['./publish-batch-modal.component.scss'],
    imports: [FormsModule, TwoDigitDecimaNumberDirective, CopyDirective, NgIf]
})
export class PublishBatchModalComponent implements OnInit {
  @Input() code: any;
  @Input() price: any;
  constructor(private router: Router,public ActiveModal: NgbActiveModal, private inventoryManagementService:InventoryManagementService,private toastService: ToastService) { }
  ngOnInit(): void {
  }
  checkPriceValidation($event){
    // tslint:disable-next-line:prefer-const
    let s = $event.target.value.split('.');
    if (s.length === 1){
      if (s[0].length >= 6) {
        $event.preventDefault();
      }
    }
  }
  publish(){
    this.inventoryManagementService.publishBatch(this.code,"publish",this.price).subscribe(
      data => {
        if(data.status === 'Product published successfully'){
          this.toastService.showAndNavigate(data.status).subscribe(_=>this.router.navigate(['inventory/inventorymanagement']));
        }else if(data.status ==='Batch update failed'){
          this.toastService.show(data.status);
        }
      }
    );
    this.ActiveModal.close('publish')
  }

}
